import { Grid, Skeleton } from '@mui/material';
import { ReportTab } from '..';

const Header = () => (
  <Grid
    item
    xs={12}
    sx={{
      mt: '25px',
      px: '18px',
      display: 'flex',
      justifyContent: 'space-between'
    }}
  >
    <Skeleton
      animation="wave"
      variant="rectangular"
      width={40}
      height={40}
      sx={{ borderRadius: '98px', bgcolor: '#DFDFDF' }}
    />
    <Skeleton
      animation="wave"
      variant="rectangular"
      width={'65%'}
      height={41}
      sx={{ borderRadius: '98px', bgcolor: '#DFDFDF' }}
    />
    <Skeleton
      animation="wave"
      variant="rectangular"
      width={40}
      height={40}
      sx={{ borderRadius: '98px', bgcolor: '#DFDFDF' }}
    />
  </Grid>
);

const Selection = () => (
  <Grid
    item
    xs={12}
    sx={{
      mt: 4,
      mb: 5.2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}
  >
    <Skeleton
      animation="wave"
      variant="rectangular"
      width={140}
      height={35}
      sx={{ borderRadius: '98px', mr: '10px' }}
    />
    <Skeleton
      animation="wave"
      variant="rectangular"
      width={100}
      height={20}
      sx={{ borderRadius: '98px', bgcolor: '#DFDFDF' }}
    />
  </Grid>
);

export const SmbgLoading = () => (
  <Grid
    container
    sx={{
      alignItems: 'flex-start',
      bgcolor: '#EEEEEE',
      width: '100%',
      height: '290px',
      borderRadius: '16px',
      mt: '1rem',
      mb: '1.2rem'
    }}
  >
    <Grid item xs={12} display="flex">
      <Skeleton
        animation="wave"
        variant="rectangular"
        width={24}
        height={24}
        sx={{
          borderRadius: '4px',
          marginX: '0',
          mt: '1.7rem',
          mr: 2,
          position: 'absolute',
          bgcolor: '#DFDFDF'
        }}
      />
      <Skeleton
        animation="wave"
        variant="rectangular"
        width={'40%'}
        height={25}
        sx={{
          borderRadius: '98px',
          marginX: 'auto',
          mt: '1.5rem',
          bgcolor: '#DFDFDF'
        }}
      />
    </Grid>
    <Grid item xs={12}>
      {[...Array(4)].map((_) => (
        <div
          style={{
            marginBottom: '20px',
            display: 'grid',
            placeItems: 'center'
          }}
        >
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={'85%'}
            height={25}
            sx={{ borderRadius: '98px', bgcolor: '#DFDFDF' }}
          />
        </div>
      ))}
    </Grid>
  </Grid>
);

export const PieChartLoading = () => {
  return (
    <div style={{ width: '100%' }}>
      <Grid item xs={12} display="flex">
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={24}
          height={24}
          sx={{
            borderRadius: '4px',
            marginX: '0',
            mt: '1.7rem',
            mr: 2,
            position: 'absolute',
            bgcolor: '#DFDFDF'
          }}
        />
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={'40%'}
          height={25}
          sx={{
            borderRadius: '98px',
            marginX: 'auto',
            mt: '1.5rem',
            bgcolor: '#DFDFDF'
          }}
        />
      </Grid>
      <div
        style={{
          position: 'relative',
          display: 'grid',
          placeItems: 'center',
          width: '100%'
        }}
      >
        <Skeleton
          animation="wave"
          variant="circular"
          width={223}
          height={224}
          sx={{
            bgcolor: '#EEEEEE',
            borderRadius: '50%',
            marginX: 'auto',
            mt: '2rem',
            position: 'relative',
            borderWidth: '50px',
            borderColor: '#DFDFDF',
            borderStyle: 'solid'
          }}
        />
        <Skeleton
          animation="wave"
          variant="circular"
          width={'25%'}
          height={20}
          sx={{
            bgcolor: '#DFDFDF',
            borderRadius: '98px',
            margin: '2rem auto 0'
          }}
        />
        <Skeleton
          animation="wave"
          variant="circular"
          width={'90%'}
          height={20}
          sx={{
            bgcolor: '#DFDFDF',
            borderRadius: '98px',
            margin: '1rem auto 0'
          }}
        />
      </div>
    </div>
  );
};

export const BarChartLoading = () => (
  <Grid container>
    <Grid
      container
      spacing={1}
      style={{ justifyContent: 'center', marginTop: '40px' }}
    >
      {[...Array(7)].map((_) => (
        <Grid item style={{ width: '13%' }}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            // width={32}
            height={209}
            sx={{ borderRadius: '5px', bgcolor: '#DFDFDF' }}
          />
        </Grid>
      ))}
      <Grid xs={12} item>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={'40%'}
          height={25}
          sx={{
            borderRadius: '98px',
            margin: '1.5rem auto 1rem',
            bgcolor: '#DFDFDF'
          }}
        />
      </Grid>
    </Grid>
  </Grid>
);

export const RiskAnalysisLoading = () => (
  <Grid
    container
    sx={{
      alignItems: 'flex-start',
      bgcolor: '#EEEEEE',
      borderRadius: '16px',
      marginTop: '19px'
    }}
  >
    <Grid container>
      <Grid item xs={12} display="flex">
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={24}
          height={24}
          sx={{
            borderRadius: '4px',
            marginX: '0',
            mt: '1.7rem',
            mr: 2,
            position: 'absolute',
            bgcolor: '#DFDFDF'
          }}
        />
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={'40%'}
          height={22}
          sx={{
            borderRadius: '98px',
            marginX: 'auto',
            mt: '1.5rem',
            bgcolor: '#DFDFDF'
          }}
        />
      </Grid>

      <Grid xs={12} item>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={'50%'}
          height={16}
          sx={{
            borderRadius: '98px',
            margin: '1rem auto 1rem',
            bgcolor: '#DFDFDF'
          }}
        />
      </Grid>
      <Grid xs={12} item>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={'40%'}
          height={25}
          sx={{
            borderRadius: '98px',
            margin: '1rem auto 1rem',
            bgcolor: '#DFDFDF'
          }}
        />
      </Grid>
      {[...Array(4)].map((_) => (
        <Grid xs={12} item>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={'85%'}
            height={25}
            sx={{
              borderRadius: '98px',
              margin: '0.3rem auto 1rem',
              bgcolor: '#DFDFDF'
            }}
          />
        </Grid>
      ))}
      <Grid xs={12} item>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={'50%'}
          height={25}
          sx={{
            borderRadius: '98px',
            margin: '1rem auto 1rem',
            bgcolor: '#DFDFDF'
          }}
        />
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ justifyContent: 'center', marginTop: '15px' }}
      >
        {[...Array(7)].map((_) => (
          <Grid item style={{ width: '13%' }}>
            <Skeleton
              animation="wave"
              variant="rectangular"
              // width={32}
              height={209}
              sx={{ borderRadius: '5px', bgcolor: '#DFDFDF' }}
            />
          </Grid>
        ))}
        <Grid xs={12} item>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={'90%'}
            height={40}
            sx={{
              borderRadius: '98px',
              margin: '2.5rem auto 1rem',
              bgcolor: '#DFDFDF'
            }}
          />
        </Grid>
        <Grid xs={12} item>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={'40%'}
            height={32}
            sx={{
              borderRadius: '98px',
              margin: '1.6rem auto 2rem',
              bgcolor: '#DFDFDF'
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export const LastItemsLoading = () =>
  [...Array(2)].map((_, index) => (
    <Grid
      key={index}
      item
      xs={12}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        mt: index === 0 && 2.5,
        bgcolor: '#EEEEEE',
        height: '60px',
        borderRadius: '16px',
        mb: 2
      }}
    >
      <Skeleton
        animation="wave"
        variant="rectangular"
        width={'40%'}
        height={25}
        sx={{ borderRadius: '98px', bgcolor: '#DFDFDF' }}
      />
      <Skeleton
        animation="wave"
        variant="rectangular"
        width={24}
        height={24}
        sx={{
          borderRadius: '4px',
          mr: 2,
          position: 'absolute',
          right: '10px',
          bgcolor: '#DFDFDF'
        }}
      />
    </Grid>
  ));

export const PatientReportLoading = () => {
  return (
    <Grid container>
      <Header />
      <Grid item xs={12} mt={2}>
        <ReportTab activeTab={1} showSkeleton />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          px: '16px',
          background:
            'linear-gradient(184deg, #FFFFFF, #F5F5F5 42.19%, #F5F5F5 100%)'
        }}
      >
        <Selection />
        <SmbgLoading />
        <Grid
          container
          sx={{
            alignItems: 'flex-start',
            bgcolor: '#EEEEEE',
            borderRadius: '16px'
          }}
        >
          <PieChartLoading />
          <BarChartLoading />
        </Grid>
        <LastItemsLoading />
      </Grid>
    </Grid>
  );
};
